import { login } from '@/api/login'
import { init } from '@/api/init'
import { status } from '@/api/status'
import { register } from '@/api/register'
import { getToken, returnMsg } from '@/utils'
import { theme } from '@/utils/theme'

export default {
  login ({ commit }, params) {
    return new Promise((resolve, reject) => {
      login(params).then(res => {
        resolve(res.data)
      }).catch(() => {
        resolve(returnMsg())
      })
    })
  },
  register ({ commit }, params) {
    return new Promise((resolve, reject) => {
      register(params).then(res => {
        resolve(res.data)
      }).catch(() => {
        resolve(returnMsg())
      })
    })
  },
  getInit ({ commit }) {
    return new Promise((resolve, reject) => {
      init().then(res => {
        if (res.data.ret === 1) {
          commit('SET_INIT', res.data.data)
          commit('SET_THEMECONFIG', theme[2].theme)
          commit('SET_ISINIT', true)
          if (res.data.data.title) document.title = res.data.data.title
        }
        resolve(res.data)
      }).catch(() => {
        resolve(returnMsg())
      })
    })
  },
  getStatus ({ commit }) {
    return new Promise((resolve, reject) => {
      status({ session_id: getToken(), pop_type: 1 }).then(res => {
        if (res.data.ret === 1) {
          commit('SET_STATUS', res.data.data)
        }
        resolve(res.data)
      }).catch(() => {
        resolve(returnMsg())
      })
    })
  }
}
